import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { FileUploadWUT as FileUploadFieldWUT } from '../../../ui/file-upload';
export const FileUploadWUT = (props)=>{
    const fieldType = FIELD_TYPES.FILE_UPLOAD;
    return /*#__PURE__*/ React.createElement(FileUploadFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=file-upload-wut.js.map